export function client (state) {
  return state?.client?.data
}
